class AuthService {
  private sessionToken: string | null = null;
  private businessId: string | null = null;
  private tokenSubscribers: ((token: string) => void)[] = [];

  setAuthToken(token: string, businessId?: string): void {
    this.sessionToken = token;
    localStorage.setItem('session_token', token);
    if (businessId) {
      this.businessId = businessId;
      localStorage.setItem('oauth_business_id', businessId);
      localStorage.setItem('selected_business_id', businessId);
    }
    
    const subs = [...this.tokenSubscribers];
    this.tokenSubscribers = [];
    subs.forEach((cb) => cb(token));
  }

  waitForNewToken(timeoutMs = 10000): Promise<string | null> {
    return new Promise((resolve) => {
      let timeoutId: any;
      const callback = (token: string) => {
        clearTimeout(timeoutId);
        resolve(token);
      };
      timeoutId = setTimeout(() => {
        this.tokenSubscribers = this.tokenSubscribers.filter((cb) => cb !== callback);
        resolve(null);
      }, timeoutMs);
      this.tokenSubscribers.push(callback);
    });
  }

  loadCachedIframeToken(): boolean {
    const token = localStorage.getItem('session_token');
    const businessId = localStorage.getItem('oauth_business_id') || localStorage.getItem('selected_business_id') || undefined;
    if (!token) return false;
    this.sessionToken = token;
    if (businessId) this.businessId = businessId;
    return true;
  }

  isAuthenticated(): boolean {
    return !!this.sessionToken;
  }

  getBusinessId(): string | null {
    return this.businessId || localStorage.getItem('oauth_business_id') || localStorage.getItem('selected_business_id');
  }

  getSessionToken(): string | null {
    return this.sessionToken ?? localStorage.getItem('session_token');
  }
}

export const authService = new AuthService();
